module.exports = __webpack_public_path__ + "img/white1.0fb7fed5.gif";